import React from "react"
import RandomPositionedAvatars from "components/atoms/Avatars/RandomPositionedAvatars"
import LinearPositionedAvatars from "components/atoms/Avatars/LinearPositionedAvatars"

type AvatarsProps = {
  type?: "random" | "linear";
  users: Record<string, any>[];
  avatarKey?: string;
}

export default function Avatars(props: AvatarsProps) {
  const { users, avatarKey = "avatar", type = "random" } = props

  return (
    type === "random" ? <RandomPositionedAvatars users={users} avatarKey={avatarKey}/> :
      <LinearPositionedAvatars users={users} avatarKey={avatarKey}/>
  )
}
